import { ACCOUNTANT_ROLE, MANAGER_ROLE } from '@Shared/constants/user_profile_constants';
export function isManagerCheck(userProfile) {
    return isManagerFlagCheck(userProfile) || userProfile.can_manager_approve;
}
export function isManagerFlagCheck(userProfile) {
    return (userProfile === null || userProfile === void 0 ? void 0 : userProfile.role) === MANAGER_ROLE;
}
export function checkIsManager(managedUserProfile, managerUserProfile) {
    return (managedUserProfile === null || managedUserProfile === void 0 ? void 0 : managedUserProfile.manager_user_profile_id) === managerUserProfile.id;
}
export function isAdminCheck(userProfile) {
    return userProfile.is_admin;
}
export function isAccountantCheck(userProfile) {
    return userProfile.role === ACCOUNTANT_ROLE;
}
export function isAdminOrAccountantCheck(userProfile) {
    return userProfile.is_admin || userProfile.role === ACCOUNTANT_ROLE;
}
